/// HOOKS ///
import { useNavigate } from "react-router-dom";
/// FM ///
import { motion } from "framer-motion";
/// MUI ///
import { Grid } from "@mui/material";
import { Typography } from "@mui/material";
/// TYPES ///
import { ICustomer } from "api/types/customer";
/// URLS ///
import { detail_url } from "components/navigation/endpoints";
import { end_customer_url } from "components/navigation/endpoints";
/// STYLES ///
import { row_btn_style } from "styles/universal/row";
import { row_text_item_style } from "styles/universal/row";
/// MOTION ///
import { row_text_motion } from "styles/universal/row";

interface Props {
  item: ICustomer
}

export default function CustomerItem({ item }: Props) {
  const navigate = useNavigate();
  return (
    <Grid item xs={12}>
      <motion.button
        initial="rest"
        whileHover="hover"
        animate="rest"
        variants={row_text_motion}
        onClick={() => navigate(`/${end_customer_url}/${detail_url}/${item.id}`)}
        style={row_btn_style}>
        <Grid container>
          <Grid item xs={4} md={2}>
            <Typography variant="body2" align="left" noWrap sx={row_text_item_style}>
              {!item.is_business ? `${item.last_name}, ${item.first_name}` : item.business_name}
            </Typography>
          </Grid>
          <Grid item xs={4} md={3}>
            <Typography variant="body2" align="left" noWrap sx={row_text_item_style}>
              {item.address}
            </Typography>
          </Grid>
          <Grid item xs={0} md={2} sx={{display: {xs: "none", md: "block"}}}>
            <Typography variant="body2" align="left" noWrap sx={row_text_item_style}>
              {item.city}
            </Typography>
          </Grid>
          <Grid item xs={0} md={2} sx={{display: {xs: "none", md: "block"}}}>
            <Typography variant="body2" align="left" noWrap sx={row_text_item_style}>
              {item.phone_number}
            </Typography>
          </Grid>
          <Grid item xs={4} md={3}>
            <Typography variant="body2" align="left" noWrap sx={row_text_item_style}>
              {item.email}
            </Typography>
          </Grid>
        </Grid>
      </motion.button>
    </Grid>
  )
}
